import resource from './resource/store';
import shop from './shop/store';

export default {
  namespaced: true,
  modules: { shop, resource },
};
